import React, { Component } from 'react'
import io from '../../utils/socket-client';
import Modal from 'react-modal';
import DatePicker from 'react-datepicker';
import JqxDropDownList from '../../widgets/jqwidgets-react/react_jqxdropdownlist';
import AccessGrid from './AccessGrid';
import 'react-datepicker/dist/react-datepicker.css';
import AccessGridFilterCustomerContainer from "./AccessGridFilterCustomerContainer";

export default class AccessGridContainer extends Component {

    constructor(props){
        super(props);
        this.state = {
            modalIsOpen: false,
            userLogin: null,
            promoterLogin: null,
            promoterGroupNames: null,
            modalPassValidation: false
        };
    }

    openNewAccessModal() {
        let userListOptions = [];
        if(this.props.users && this.props.users.length) {
            this.props.users.forEach((item) => {
                let label = item.userName + ' (' + item.login + ')';
                if(item.type === 'customer') {
                    userListOptions.push({label: label, login: item.login, name: item.userName});
                }
            });
        }
        function sort(a, b){
            let aName = a.name, bName = b.name;
            if(aName < bName) return -1;
            else if(aName > bName) return 1;
            else if(aName === bName) return 0;
        }
        userListOptions.sort(sort);

        let promoterListOptions = [];
        if(this.props.groups && this.props.groups.length) {
            let users = [];
            this.props.groups.forEach((item) => {
                if(!users.length || !users.filter((i) => {return i.login === item.login}).length){
                    users.push({login: item.login, userName: item.userName, groupNames: []});
                } 
                users.forEach((user) =>{
                    if(user.login === item.login){
                        user.groupNames.push(item.groupName);
                    }
                });
            });
            users.forEach((user) =>{
                let label = user.userName + ' (' + user.groupNames + ')';
                promoterListOptions.push({label: label, login: user.login, name: user.userName, groupNames: user.groupNames});
            });
        }
        promoterListOptions.sort(sort);

        this.setState({
            modalIsOpen: true,
            userLogin: null,
            promoterLogin: null,
            modalPassValidation: false
        });

        setTimeout(() => {
            this.refs.userList.source(userListOptions);
            this.refs.promoterList.source(promoterListOptions);
            this.refs.userList.on('change', this.changeDropDownValue.bind(this, 'user'));
            this.refs.promoterList.on('change', this.changeDropDownValue.bind(this, 'promoter'));
        }, 0);
    }

    componentDidMount(){
        this.grid = this.refs.grid.refs.grid;
        this.gridData = this.refs.grid.source.localdata;
    }

    closeModal() {
        this.props.clearError();
        this.setState({modalIsOpen: false});
    }

    addAccess(event){
        console.log(this.state);
        event.preventDefault();
        if(this.state.startDate && this.state.endDate){
            if(this.state.startDate > this.state.endDate) {
                this.props.setError('Дата конца не может быть раньше даты начала!');
                return false;
            }
        }
        let newAccess = {
            userLogin: this.state.userLogin,
            promoterLogin: this.state.promoterLogin,
            groupNames: []
        };
        if(this.state.startDate){
            newAccess.startDate = this.state.startDate._d;
        }
        if(this.state.endDate){
            newAccess.endDate = this.state.endDate._d;
        }
        io.sendChange({
            uri:io.ACCESS_URI,
            operation: io.OPERATION_CREATE,
            data: newAccess,
            success: () => {
                newAccess.userName = this.state.userName;
                newAccess.promoterName = this.state.promoterName;
                newAccess.groupNames = this.state.promoterGroupNames;
                this.grid.addrow(null, newAccess);
                this.gridData.push(newAccess);
                this.grid.updaterow(this.gridData.length -1, newAccess);
                this.closeModal();
                this.setState({startDate: null, endDate: null});
            },
            fail: () => {
                this.closeModal();
                this.setState({startDate: null, endDate: null});
            }
        });

    }

    changeDropDownValue(field, event){
        let login = event.args.item.originalItem.login;
        let name = event.args.item.originalItem.name;
        if(login){
            switch(field){
                case 'user':
                    this.setState({userLogin: login, userName: name});
                    break;
                case 'promoter':
                    this.setState({promoterLogin: login, promoterName: name, promoterGroupNames: event.args.item.originalItem.groupNames});
                    break;
                default:
                    return;
            }
            setTimeout(() => {
                if (this.state.userLogin && this.state.promoterLogin) {
                    this.setState({modalPassValidation: true});
                }
            }, 0);
        }
    }

    filter(name, login){
        let filtergroup = new window.$.jqx.filter();
        let filter_or_operator = 1;
        let filtervalue = login;
        let filtercondition = 'contains';
        let filter1 = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
        filtergroup.addfilter(filter_or_operator, filter1);
        this.grid.addfilter('userLogin', filtergroup);

        filtergroup = new window.$.jqx.filter();
        filter_or_operator = 2;
        filtervalue = name;
        filtercondition = 'contains';
        let filter2 = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
        filtergroup.addfilter(filter_or_operator, filter2);
        this.grid.addfilter('userName', filtergroup);

        this.grid.applyfilters();
        this.grid.hidecolumn('userLogin');
        this.grid.hidecolumn('userName');
    }

    clearFilter(){
        this.grid.clearfilters(false);
        this.grid.showcolumn('userLogin');
        this.grid.showcolumn('userName');
    }

    render() {
        const customStyles = {
            content : {
                width              : 350,
                height              : 340,
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
            },
            overlay: {
                zIndex: 100,
            }
        };

        class CustomDateInput extends React.Component {
            render () {
                return (
                    <input type="text" style={{width: 348, fontSize: 16}} readOnly={true} onClick={this.props.onClick} value={this.props.value ? this.props.value : this.props.ph}/>
                )
            }
        }

        let customers = this.props.filterUsers.filter((item) => {
            return item.type === 'customer';
        });

        return (
            <div style={{display: 'flex', width: '100%', height: '100%', flexDirection: 'row', overflow: 'hidden'}}>
                <AccessGridFilterCustomerContainer onFilter={this.filter.bind(this)} clearFilter={this.clearFilter.bind(this)} items={customers}/>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal.bind(this)}
                        style={customStyles}
                        ariaHideApp={false}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="Добавить доступ">

                        <form style={{display: 'flex', flexDirection: 'column'}} onSubmit={this.addAccess.bind(this)} method="post">
                            <JqxDropDownList
                                style={{marginBottom: 10, fontSize: 16}}
                                ref={"userList"}
                                width={350}
                                filterable={true}
                                placeHolder={'Пользователь'}
                                filterPlaceHolder={'Поиск'}>
                            </JqxDropDownList>
                            <JqxDropDownList
                                style={{marginBottom: 10, fontSize: 16}}
                                ref={"promoterList"}
                                filterable={true}
                                width={350}
                                height={25}
                                placeHolder={'Расклейщик'}
                                filterPlaceHolder={'Поиск'}>
                            </JqxDropDownList>
                            <div style={{marginBottom: 10, display: 'flex'}}>
                            <DatePicker
                                ref={"startDatePicker"}
                                selected={this.state.startDate}
                                customInput={<CustomDateInput ph={"Начало"}/>}
                                dateFormat="DD.MM.YYYY"
                                onChange={(date) => {
                                    date._d.setHours(0);
                                    date._d.setMinutes(0);
                                    date._d.setSeconds(0);
                                    date._d.setMilliseconds(0);
                                    console.log(date._d);
                                    this.setState({startDate: date});
                                }}
                                locale="ru"/>
                            </div>
                            <div style={{marginBottom: 10, width: 350}}>
                                <DatePicker
                                    ref={"endDatePicker"}
                                    selected={this.state.endDate}
                                    dateFormat="DD.MM.YYYY"
                                    customInput={<CustomDateInput ph={"Конец"}/>}
                                    onChange={(date) => {
                                        date._d.setHours(23);
                                        date._d.setMinutes(59);
                                        date._d.setSeconds(59);
                                        date._d.setMilliseconds(999);
                                        console.log(date._d);
                                        this.setState({endDate: date});
                                    }}
                                    locale="ru"/>
                            </div>
                            <div style={{marginTop: 10, display: 'flex', justifyContent: 'space-between'}}>
                                <button style={{width: '45%', marginRight: 10, fontSize: 17}} disabled={!this.state.modalPassValidation}>Готово</button>
                                <button style={{width: '45%', fontSize: 17}} onClick={this.closeModal.bind(this)}>Отмена</button>
                            </div>
                        </form>
                    </Modal>
                <AccessGrid
                    ref={'grid'}
                    access={this.props.access}
                    users={this.props.users}
                    groups={this.props.groups}
                    openNewAccessModal={this.openNewAccessModal.bind(this)}
                    setError={this.props.setError}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/AccessGridContainer.js